<button
    [disabled]="isProcessing() || isDisabled()"
    [type]="type()"
    [class]="customClasses().button"
    (click)="click($event)"
>
    @if (isProcessing()) {
        <span [class]="customClasses().spinner" role="status" aria-hidden="true"></span>
        Processing...
    } @else {
        @if (prependIcon()) {
            <span [class]="prependIcon() + ' me-1'"></span>
        }
        {{ buttonText() }}
        @if (icon()) {
            <span [class]="icon() + ' ms-1'"></span>
        }
    }
</button>
